import {useCallback, useEffect, useRef, useState} from "react";
import Spreadsheet, { CellBase, Matrix } from "react-spreadsheet";
import { FlexAlignCenter, FlexJustifyBetweenAlignCenter } from "@/components/ui/FlexBox.ts";
import { Button } from "@/components/ui/Button.tsx";
import { ToolbarButton } from "@/pages/assistants/FilesInScenario/styles.ts";
import { AddColumn, AddRow } from "@/pages/assistants/FilesInScenario/icons.tsx";


const parseCSV = (csvString: string) => {
    const rows = csvString.split('\n').filter(row => row.trim() !== '');
    if (rows.length === 0) return [];

    const data = rows.map(row => {
        return row.split(',').map(value => ({ value: value.trim() }));
    });

    return data;
}

const toCSV = (data: Matrix<CellBase<any>>) => {
    return data
        .map(row => row.map(cell => cell?.value).join(','))
        .join('\n');
};

interface ICsvEditor {
    content: string;
    onSave: (value: string) => void;
    isLoading: boolean
}

export const CsvEditor = ({ content, onSave, isLoading }: ICsvEditor) => {
    const previousData = useRef<Matrix<CellBase<any>> | null>(null);
    const [data, setData] = useState<Matrix<CellBase<any>>>([]);
    const editorContainerRef = useRef<HTMLDivElement>(null)

    const addRow = () => {
        const newRow = data[0].map(() => ({ value: '' }));
        setData([...data, newRow]);
    };

    const addColumn = () => {
        setData(data.map(row => [...row, { value: '' }]));
        setTimeout(() => {
            if(editorContainerRef.current) {
                editorContainerRef.current.scrollLeft = editorContainerRef.current.scrollWidth;
            }
        }, 100)
    };

    const handleSpreadsheetChange = useCallback((updatedData: Matrix<CellBase<any>>) => {
        console.log(1)
        if (JSON.stringify(data) !== JSON.stringify(previousData.current)) {
            setData(updatedData);
        }

        previousData.current = updatedData;
    }, [data, previousData]);

    const handleSave = () => {
        const csvString = toCSV(data);
        onSave(csvString);
    };

    useEffect(() => {
        if(content) {
            setData(parseCSV(content))
        }
    }, [content]);

    return (
        <div>
            <FlexJustifyBetweenAlignCenter style={{marginBottom: '20px'}}>
                <FlexAlignCenter>
                    <ToolbarButton onClick={addRow}>
                        <AddRow />
                    </ToolbarButton>
                    <ToolbarButton style={{ marginLeft: '10px' }} onClick={addColumn}>
                        <AddColumn />
                    </ToolbarButton>
                </FlexAlignCenter>
                <FlexAlignCenter>
                    <Button disabled={isLoading} onClick={handleSave} variant="primary">
                        Сохранить
                    </Button>
                </FlexAlignCenter>
            </FlexJustifyBetweenAlignCenter>
            <div ref={editorContainerRef} style={{maxWidth: 'calc(100vw - 317px)', overflow: 'scroll'}}>
                <Spreadsheet data={data} onChange={handleSpreadsheetChange}/>
            </div>
        </div>
    )
}
